
export default class StringHelper {
    constructor(string) {
        this.string = string;
    }

    capitalise() {
        return this.string.charAt(0).toUpperCase() + this.string.slice(1).toLowerCase();
    }

    toCamelcase() {
        return this.string.replace(/(\-[a-z])/g, letter => letter.toUpperCase().replace('-', ''));
    }

    toSnakeCase() {
        return this.string.replace(/([A-Z])/g, letter => `_${letter.toLowerCase()}`);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/StringHelper/StringHelper.js